/*
 * @Author: Hong.Zhang
 * @Date: 2024-12-10 17:57:32
 * @Description:
 */
import { history } from '@umijs/max';

export const LOG_LEVEL = {
  VERBOSE: 0,
  DEBUG: 1,
  INFO: 2,
  WARN: 3,
  ERROR: 4,
};
export const ENABLE_LOG_LEVEL =
  ENV !== 'local' ? LOG_LEVEL.ERROR : LOG_LEVEL.VERBOSE;

export const hookLog = () => {
  // Save the original console.log
  const originalVerbose = console.log;
  const originalDebug = console.debug;
  const originalInfo = console.info;
  const originalWarn = console.warn;
  const originalError = console.error;

  function customVerbose(...args: any) {
    if (LOG_LEVEL.VERBOSE < ENABLE_LOG_LEVEL) return;
    originalVerbose.apply(console, [...args]);
  }

  function customDebug(...args: any) {
    if (LOG_LEVEL.DEBUG < ENABLE_LOG_LEVEL) return;
    originalDebug.apply(console, [...args]);
  }

  function customInfo(...args: any) {
    if (LOG_LEVEL.INFO < ENABLE_LOG_LEVEL) return;
    originalInfo.apply(console, [...args]);
  }

  function customWarn(...args: any) {
    if (LOG_LEVEL.WARN < ENABLE_LOG_LEVEL) return;
    originalWarn.apply(console, [...args]);
  }

  function customError(...args: any) {
    if (LOG_LEVEL.ERROR < ENABLE_LOG_LEVEL) return;
    originalError.apply(console, [...args]);
  }

  // Rewrite console.log
  console.log = customVerbose;
  console.debug = customDebug;
  console.info = customInfo;
  console.warn = customWarn;
  console.error = customError;
};

export const jump2ThirdPartyPage = (targetUrl: string, isReplace = false) => {
  const url = new URL(window.location.href);
  url.searchParams.set('ts', Date.now().toString());
  history.replace({ pathname: url.pathname, search: url.search });
  if (isReplace) {
    location.replace(targetUrl);
  } else {
    location.href = targetUrl;
  }
};
